<template>
  <div class="notice-wrap">
      <div class="notice-title">
          <span class="notice-icon"/>
      </div>
      <div class="notice-item-wrap">
          <div class="notice-item-list"
            v-bind:style="{ transition: this.currentNoticeIndex === 0 ? 'all 0s ease' : 'all 0.5s ease-out', top: (-this.currentNoticeIndex * 100) + '%' }"
          >
            <div class="notice-item"
                v-for="(notice , index) in this.notices"
                :key="index"
            >
                {{notice.content}}
            </div>
        </div>   
      </div>
         
  </div>
</template>

<script>
  import {mapState , mapActions} from 'vuex'

  export default {
    name: 'Notice',
    components: {
      
    },
    computed : {
      ...mapState('noticeStore' , ['notices']) ,
    },
    beforeCreate() {

    },
    created() {
      this.API_GET_NOTICES()
        .then( res => {
          
        })
    },
    mounted() {
      const timeoutId = setTimeout(() => {
          const intervalId = setInterval(() => {
              const { notices, currentNoticeIndex } = this;              
              this.currentNoticeIndex = ( currentNoticeIndex + 1 ) >= notices.length ? 0 : ( currentNoticeIndex + 1 );
          }, 3000);
      }, 3000);
    },
    data() {
      return {
        currentNoticeIndex: 0,
      }
    },
    methods: {
      ...mapActions('noticeStore' , ['API_GET_NOTICES']) ,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/styles/Global.scss";
  .notice-wrap {
      width:100%;
      height:30px;
      position: absolute;
      z-index:1;
      bottom:0;
      overflow:hidden;
      background:rgba(0,0,0, 0.5);
      display:flex;
        .notice-title {
            .notice-icon {
                width: 16px;
                height: 15px;
                display: inline-block;                
                background:url('#{$imageUrl}/images/icons/notice-icon.png');
                margin-left: 0rem;
                margin-right: .5rem;
            }
            display:flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            color:#fff;
            width:7%;
            height:100%;
            font-size:0.9rem;
        }

      .notice-item-wrap {
          width:93%;
          height:100%;
          position: relative;
          .notice-item-list {
            width:100%;
            height:100%;
            position: absolute;
            top:0%;
            .notice-item {
                display:flex;
                align-items: center;
                color:#fff;
                width:100%;
                height:100%;
            }
          }
          
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/Notice.vue